/**
 * Suporte para revelar a 2ª imagem dos produtos complementares
 * com o dedo no telemóvel (ao deslizar ou tocar).
 */
(function () {
  var activeTouchCard = null;

  function getCard(target) {
    return target && target.closest ? target.closest('.template-product .complementary-products .card-wrapper') : null;
  }

  function clearAll() {
    document.querySelectorAll('.template-product .complementary-products .card-wrapper.is-showing-secondary').forEach(function (c) {
      c.classList.remove('is-showing-secondary');
    });
    activeTouchCard = null;
  }

  // Toque na imagem com o dedo
  document.addEventListener('touchstart', function (e) {
    var card = getCard(e.target);
    var isImage = e.target.closest && e.target.closest('.card__inner');

    if (card && isImage) {
      // Se este cartão já está a mostrar a 2ª foto, o segundo toque navega para o produto
      if (card.classList.contains('is-showing-secondary')) {
        var link = card.querySelector('.card__heading a');
        if (link) {
          window.location.href = link.href;
        }
        return;
      }

      // Primeiro toque na foto: previne navegação instantânea e revela a 2ª imagem com o dedo
      e.preventDefault();
      clearAll();
      card.classList.add('is-showing-secondary');
      activeTouchCard = card;
    } else if (card) {
      // Tocou no botão "Personalizar" ou título: permite navegação normal
      clearAll();
    } else {
      // Tocou fora dos cartões: volta à imagem principal
      clearAll();
    }
  }, { passive: false });

  // Deslizar com o dedo por cima dos cartões ("passar com o dedo")
  document.addEventListener('touchmove', function (e) {
    if (!e.touches || e.touches.length === 0) return;
    var touch = e.touches[0];
    var elem = document.elementFromPoint(touch.clientX, touch.clientY);
    var card = getCard(elem);

    if (card) {
      if (activeTouchCard !== card) {
        clearAll();
        card.classList.add('is-showing-secondary');
        activeTouchCard = card;
      }
    }
  }, { passive: true });
})();
